module.exports = __webpack_public_path__ + "media/fonts/BasisGrotesquePro-Italic-8355a1b1f9f0f657ab9c448713457749.woff";